<template>
  <div class="main">
    <div class="pageTitle">
      <p>项目工时统计</p>
      <div style="float:right">
        <currentDate></currentDate>
      </div>
    </div>
    <div class="searchArea">
      <div class="weekly_search">
        <div class="search_input">
          <el-input :value="listQuery.Parameters.projectName" readonly></el-input>
          <div class="tableChoose_btn">
                        <el-button
                          type="text"
                          size="medium"
                          @click="showChooseProjectView()"
                        >选择</el-button>
                        <el-button
                          type="text"
                          size="medium"
                          @click="clearProject()"
                        >清除</el-button>
                      </div>
        </div>
       
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          value-format="yyyy/MM/dd"
          @change="selectDate"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="margin-left:20px;"></el-date-picker>
        <div style="display: inline-block;">
          <el-button type="text" class="defaultBtn" @click="searchTable">查询</el-button>
          <!-- <el-button type="text" class="defaultBtn" @click="exportToExcel">导出EXCEL</el-button> -->
        </div>
      </div>
    </div>
 <div class="tableContainer" style="top: 120px;">
   <div class="tableContent">
        <el-table :data="spentTimeData" border stripe>
          <el-table-column prop="userName" label="姓名" width="120" fixed="left"></el-table-column>
          <el-table-column prop="organizationName" label="组织机构" width="350" fixed="left"></el-table-column>
           <el-table-column prop="spentTime" label="总计" width="100"></el-table-column>
          <el-table-column v-for="val in taskList" :key="val">
            <template slot="header">
              {{
              val.split('-')[1]
              }}
            </template>
            <template slot-scope="props">{{props.row[val]||""}}</template>
          </el-table-column>
        </el-table>
   </div>
     
        <div class="tablePagesNumber">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.PagingInfo.currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="listQuery.PagingInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.PagingInfo.totalCount"
          ></el-pagination>
        </div>
      </div>

    <chooseProject
        ref="chooseProject"
        :propsData="projectChooseViewProps"
        @chooseProjectCallback="chooseProjectCallback"></chooseProject>

  </div>
</template>
<script>
import { dateFtt } from "@/utils/auth.js";
import currentDate from "../common/currentDate";
import chooseProject from "../common/chooseProject";

export default {
  name: "userSpentTimeGroupByProject",
  components: {chooseProject, currentDate },
  data() {
    return {
      projectChooseViewProps: {
        visible: false
      },
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          projectId: "",
          projectName:"",
          startDate: "",
          endDate: ""
        }
      },
      dateRange: [],
      spentTimeData: [],
      taskList:[]
    };
  },
  mounted() {
    this.searchTable();
  },
  methods: {

    selectDate() {
      if (this.dateRange == null) {
        this.listQuery.Parameters.startDate = "";
        this.listQuery.Parameters.endDate = "";
      } else {
        this.listQuery.Parameters.startDate = this.dateRange[0];
        this.listQuery.Parameters.endDate = this.dateRange[1];
      }
    },
    searchTable() {
      
      if(this.listQuery.Parameters.projectId == null || this.listQuery.Parameters.projectId == "")
      {
        this.$alert("请选择要查询的项目。", "提示");
        return;
      }

      this.$reportApi.getUserSpentTimeDataTableGroupByProject(this.listQuery)
        .then(res => {
          if (res.data.successful) {
            this.spentTimeData = res.data.data.data;
            this.listQuery.PagingInfo.totalCount = res.data.data.pagingInfo.totalCount;
            
            this.getTaskTableColumnList()

          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },

    getTaskTableColumnList(){
        let taskList = [];
        this.spentTimeData.forEach(item=>{
            for(let key in item){
                if(key.indexOf('-') !='-1'){
                    taskList.push(key)
                }
            }
        })
        // 数组去重
        this.taskList =[...new Set(taskList)];
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.searchTable();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.searchTable();
    },

    //选择项目弹窗
    showChooseProjectView() {
      this.$refs.chooseProject.show();
    },

    //选择项目回调
    chooseProjectCallback(args) {
      this.projectChooseViewProps.visible = false;

      this.listQuery.Parameters.projectId = args.id;
      this.listQuery.Parameters.projectName = args.name;

    },

     //清除项目
    clearProject() {
      this.listQuery.Parameters.projectId = "";
      this.listQuery.Parameters.projectName = "";
    },
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-tabs.el-tabs--top {
  margin-top: 20px;
}
.el-tabs__active-bar {
  background-color: #95b4d1;
}
.search_input {
  width: 220px;
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.search_select {
  display: inline-block;
  margin-left: 20px;
}
.weekly_search {
  margin-top: 20px;
}

// .weekly_search .el-input {
//   width: 150px;
// }
</style>



// WEBPACK FOOTER //
// src/views/report/userSpentTimeGroupByProject.vue